import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Pencil, Trash2, Users, Calendar, Copy, Link2 } from 'lucide-react';

const tomA = () => ({
  navn: '', slug: '', beskrivelse: '', sted: '', start: '', slutt: '',
  pamelding_aapen: true, krever_betaling: false, pris: 0,
  maks_deltakere: 0, publisert: true, paameldingsfrist: '',
});

const Arrangement = () => {
  const [liste, setListe] = useState(null);
  const [open, setOpen] = useState(false);
  const [redigerer, setRedigerer] = useState(null);
  const [skjema, setSkjema] = useState(tomA());
  const [valgt, setValgt] = useState(null);
  const [paameld, setPaameld] = useState([]);

  const last = useCallback(() => {
    api.get('/arrangement').then((r) => setListe(r.data));
  }, []);
  useEffect(() => { last(); }, [last]);

  const aapne = (a) => {
    setRedigerer(a);
    setSkjema(a ? { ...tomA(), ...a } : tomA());
    setOpen(true);
  };
  const lagre = async () => {
    if (!skjema.navn.trim()) { alert('Navn er påkrevd.'); return; }
    if (redigerer) await api.put(`/arrangement/${redigerer.id}`, skjema);
    else await api.post('/arrangement', skjema);
    setOpen(false); last();
  };
  const slett = async (a) => {
    if (!window.confirm(`Slett arrangement "${a.navn}"?`)) return;
    await api.delete(`/arrangement/${a.id}`); last();
  };
  const visPaameld = async (a) => {
    setValgt(a);
    const r = await api.get(`/arrangement/${a.id}/paameldinger`);
    setPaameld(r.data);
  };
  const kopierLink = (a) => {
    const url = `${window.location.origin}/a/${a.slug}`;
    navigator.clipboard.writeText(url);
    alert(`Påmeldingslenke kopiert:\n${url}`);
  };

  if (!liste) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader
        title="Arrangement"
        subtitle="Aktiviteter med påmelding"
        actions={
          <button className="btn-primary" onClick={() => aapne(null)}>
            <Plus size={14} /> Nytt arrangement
          </button>
        }
      />
      <Card>
        <table className="fm-table">
          <thead>
            <tr>
              <th>Navn</th><th>Sted</th><th>Start</th>
              <th>Påmeldte</th><th>Pris</th><th></th>
            </tr>
          </thead>
          <tbody>
            {liste.map((a) => (
              <tr key={a.id}>
                <td>
                  <strong>{a.navn}</strong>
                  {a.publisert && <span className="badge badge-success" style={{ marginLeft: 8 }}>Publisert</span>}
                </td>
                <td>{a.sted}</td>
                <td>{a.start ? new Date(a.start).toLocaleString('nb-NO') : ''}</td>
                <td>{a.antall_paameldte}{a.maks_deltakere ? ` / ${a.maks_deltakere}` : ''}</td>
                <td>{a.krever_betaling ? `${a.pris} kr` : 'Gratis'}</td>
                <td style={{ textAlign: 'right' }}>
                  <button className="btn-ghost" title="Kopier lenke" onClick={() => kopierLink(a)}><Link2 size={14} /></button>
                  <button className="btn-ghost" title="Påmeldte" onClick={() => visPaameld(a)}><Users size={14} /></button>
                  <button className="btn-ghost" onClick={() => aapne(a)}><Pencil size={14} /></button>
                  <button className="btn-ghost" onClick={() => slett(a)}><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
            {liste.length === 0 && (
              <tr><td colSpan={6} className="fm-text-muted" style={{ textAlign: 'center', padding: 24 }}>
                Ingen arrangement opprettet enda.
              </td></tr>
            )}
          </tbody>
        </table>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)}
             title={redigerer ? 'Rediger arrangement' : 'Nytt arrangement'}
             footer={<button className="btn-primary" onClick={lagre}>Lagre</button>}>
        <div className="fm-grid-2">
          <label>Navn *<input value={skjema.navn} onChange={(e) => setSkjema({ ...skjema, navn: e.target.value })} /></label>
          <label>Slug (URL)<input value={skjema.slug} onChange={(e) => setSkjema({ ...skjema, slug: e.target.value })} placeholder="auto-genereres" /></label>
          <label>Sted<input value={skjema.sted} onChange={(e) => setSkjema({ ...skjema, sted: e.target.value })} /></label>
          <label>Maks deltakere (0 = ubegrenset)<input type="number" value={skjema.maks_deltakere} onChange={(e) => setSkjema({ ...skjema, maks_deltakere: Number(e.target.value) })} /></label>
          <label>Start<input type="datetime-local" value={skjema.start ? skjema.start.slice(0,16) : ''} onChange={(e) => setSkjema({ ...skjema, start: e.target.value })} /></label>
          <label>Slutt<input type="datetime-local" value={skjema.slutt ? skjema.slutt.slice(0,16) : ''} onChange={(e) => setSkjema({ ...skjema, slutt: e.target.value })} /></label>
          <label>Påmeldingsfrist<input type="datetime-local" value={skjema.paameldingsfrist ? skjema.paameldingsfrist.slice(0,16) : ''} onChange={(e) => setSkjema({ ...skjema, paameldingsfrist: e.target.value })} /></label>
          <label>Pris (kr)<input type="number" value={skjema.pris} onChange={(e) => setSkjema({ ...skjema, pris: Number(e.target.value) })} /></label>
        </div>
        <label style={{ display: 'block', marginTop: 12 }}>Beskrivelse
          <textarea rows={5} value={skjema.beskrivelse} onChange={(e) => setSkjema({ ...skjema, beskrivelse: e.target.value })} />
        </label>
        <div style={{ display: 'flex', gap: 16, marginTop: 12, flexWrap: 'wrap' }}>
          <label><input type="checkbox" checked={skjema.pamelding_aapen} onChange={(e) => setSkjema({ ...skjema, pamelding_aapen: e.target.checked })} /> Påmelding åpen</label>
          <label><input type="checkbox" checked={skjema.krever_betaling} onChange={(e) => setSkjema({ ...skjema, krever_betaling: e.target.checked })} /> Krever betaling</label>
          <label><input type="checkbox" checked={skjema.publisert} onChange={(e) => setSkjema({ ...skjema, publisert: e.target.checked })} /> Publisert</label>
        </div>
      </Modal>

      <Modal open={!!valgt} onClose={() => setValgt(null)}
             title={valgt ? `Påmeldte – ${valgt.navn}` : ''} width={720}>
        <table className="fm-table">
          <thead><tr><th>Navn</th><th>E-post</th><th>Telefon</th><th>Status</th><th>Betalt</th><th>Dato</th></tr></thead>
          <tbody>
            {paameld.map((p) => (
              <tr key={p.id}>
                <td>{p.navn}</td><td>{p.epost}</td><td>{p.telefon}</td>
                <td><span className={`badge ${p.status === 'paameldt' ? 'badge-success' : 'badge-warning'}`}>{p.status}</span></td>
                <td>{p.betalt ? '✓' : ''}</td>
                <td>{p.opprettet ? new Date(p.opprettet).toLocaleDateString('nb-NO') : ''}</td>
              </tr>
            ))}
            {paameld.length === 0 && (
              <tr><td colSpan={6} className="fm-text-muted" style={{ textAlign: 'center', padding: 24 }}>
                Ingen påmeldte enda.
              </td></tr>
            )}
          </tbody>
        </table>
      </Modal>
    </>
  );
};

export default Arrangement;
